var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import styled from 'styled-components';
var PageTitle = function (_a) {
    var _b = _a.gridSize, gridSize = _b === void 0 ? 12 : _b, title = _a.title;
    return (React.createElement(Grid, { item: true, xs: gridSize },
        React.createElement(StyledTypography, { variant: "h3" }, title)));
};
var StyledTypography = styled(Typography)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  font-size: 1.5em;\n  margin-block-start: 0.83em;\n  margin-block-end: 0.83em;\n  margin-inline-start: 0px;\n  margin-inline-end: 0px;\n  font-weight: bold;\n"], ["\n  display: block;\n  font-size: 1.5em;\n  margin-block-start: 0.83em;\n  margin-block-end: 0.83em;\n  margin-inline-start: 0px;\n  margin-inline-end: 0px;\n  font-weight: bold;\n"])));
export default PageTitle;
var templateObject_1;
